import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=15f97c5d&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "menu.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/base/menu/menu.vue
// module id = 128
// module chunks = 0